<template>
  <!-- <p class="component-heading">{{$t('invoice.invoice')}}</p> -->
  <b-row
    v-if="
      showone == 'GRN Without PO' ||
      showone == 'GRN With PO' ||
      showone == 'Opening Stock' ||
      showone == 'DC'
    "
  >
    <b-col lg="6" md="6" sm="12">
      <!-- {{ invDetails }} -->
      <div class="field">
        <TextField
          :label="
            showone == 'DC'
              ? $t('invoice.DCInvoiceNumber')
              : $t('invoice.invoicenumber')
          "
          v-model="invDetails.InvoiceNo"
          type="text"
          clearable
          name="Invoice Number"
          @update:modelValue="update"
          :rules="{ required: true }"
          :required-icon="true"
          id="InvoiceNumber"
          :disabled="invoicedisable"
        />
      </div>
    </b-col>
    <b-col lg="6" md="6" sm="12">
      <div class="field">
        <!-- {{ invDetails.InvoiceDate }} -->
        <Datepicker
          :maxDate="maxDate"
          v-model="invDetails.InvoiceDate"
          :rules="{ required: true }"
          :required-icon="true"
          @update:modelValue="update"
          :label="
            showone == 'DC'
              ? $t('invoice.DCInvoiceDate')
              : $t('invoice.invoicedate')
          "
          name="Invoice Date"
          id="Invoice Date"
          dateFormat="dd-mm-yy"
          :disabled="invoicedisable"
        />
      </div>
    </b-col>
  </b-row>
</template>
<script lang="ts">
import { defineComponent, ref, reactive, onMounted } from "vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import { boolean } from "yup";

export default defineComponent({
  props: {
    showone: {
      type: String,
      default: "",
    },
    value: {},
    invoicedisable: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    TextField,
    Datepicker,
  },
  setup(props, { emit }) {
    debugger;
    const maxDate = ref(new Date());

    const invDetails = reactive({
      InvoiceNo: "",
      InvoiceDate: "",
    });
    onMounted(() => {
      Object.assign(invDetails, props.value);
    });
    function update() {
      emit("update:modelValue", invDetails);
    }
    return {
      invDetails,
      update,
      maxDate,
    };
  },
});
</script>
